const config = {
  SWIPE_DURATION: 400, // ms
  MOBILE_BREAKPOINT: 500, // px (width)
  PLAY_IN_BACKGROUND: false, // true = all players will be playing in the background
};

export default config;
